<template>
  <div class="car-details_nav-content car-details_nav-content__active">
    <!-- Head -->
    <div>
      <div class="car-details_head" v-if="routeCar">
        <!-- Поездка -->
        <div v-if="routeCar.type === 0" class="car-details_head-cnt">
          <span class="l-title">Поездка</span>
          <div>
            <span class="l-title">{{Math.round(routeCar.distance)}}</span>км
          </div>
        </div>
        <!-- Стоянка -->
        <div v-else-if="routeCar.type === 1">
          <div v-if="!autostart" class="car-details_head-cnt">
            <span class="l-title">Стоянка</span>
            <!-- Больше года -->
            <div v-if="parkingPeriod.type === 0">
              <span class="l-title">{{parkingPeriod.val1}}</span>
            </div>
            <!-- Дни часы, меньше года -->
            <div v-else-if="parkingPeriod.type === 1">
              <span class="l-title">{{parkingPeriod.val1}}</span> дн
              <span class="l-title">{{parkingPeriod.val2}}</span> ч
            </div>
            <!-- Часы минуты, меньше суток-->
            <div v-else-if="parkingPeriod.type === 2">
              <span class="l-title">{{parkingPeriod.val1}}</span> ч
              <span class="l-title">{{parkingPeriod.val2}}</span> мин
            </div>
          </div>
          <div class="car-details_head-cnt" v-else>
            <span class="l-title">Автозапуск</span>
            <div>
              осталось
              <span class="l-title">{{ stateCar.engine.remote_start_time  }}</span> мин
            </div>
          </div>
        </div>
        <div v-else>
          <div class="car-details_head-cnt">
            <span class="l-title">Нет сведений о движении авто</span>
          </div>
        </div>
      </div>
      <div class="car-details_head" v-else>
        <div class="car-details_head-cnt">
          <span class="l-title">Сведения о движении авто недоступны</span>
        </div>
      </div>
    </div>
    <!-- Состояние -->
    <div class="car-details_content">
			<!-- Main params -->
			<div class="car-details_main">
				<div class="car-details_gsm" v-if="stateCar.is_online === true">
					<img src="../../assets/img/carmanager/gsm_icon.svg">
					<div class="car-details_gsm__active" v-bind:style="{ width : 40 + 10 * stateCar.gsm_rssi + '%' }">
						<img src="../../assets/img/carmanager/gsm_icon__active.svg">
					</div>
				</div>
				<div class="car-details_gsm" v-if="stateCar.is_online === false">
					<img src="../../assets/img/carmanager/gsm-icon__disabled.svg">
				</div>
				<div class="car-details_address"
						 v-if="routeCar"
						 v-bind:class="{ 'car-details_address__stop' : routeCar.type === 1 }">
					<span v-if="parkingAddress">{{parkingAddress}}</span>
					<span v-else>Отсутствуют данные о местонахождении</span>
				</div>
				<div class="car-details_speed">
					<div class="car-details_subtitle">
						Скорость
					</div>
					<div class="car-details_icon">
						<img src="../../assets/img/dashboard/speed.svg">
					</div>
					<span class="m-title">{{stateCar.speed}}</span>км/ч
				</div>
				<div class="car-details_acum" v-on:click="changeBatteryVoltageType()" v-if="stateCar.battery_voltage">
					<div class="car-details_subtitle">
						Аккумулятор
					</div>
					<div class="car-details_icon">
						<img src="../../assets/img/dashboard/acum.svg">
					</div>
					<span v-if="batteryVoltageType === 0">
						<span class="m-title">{{stateCar.battery_voltage.value}}</span>В
					</span>
					<span v-else>
						<span class="m-title">{{stateCar.battery_voltage.percent}}</span>%
					</span>
				</div>
				<div class="car-details_fuel" v-if="stateCar.fuel">
					<div class="car-details_subtitle">
						Топливо
					</div>
					<div class="car-details_icon">
						<img src="../../assets/img/dashboard/feel.svg">
					</div>
					<span class="m-title">{{stateCar.fuel.value}}</span>
					<span v-if="stateCar.fuel.type === 1">%</span>
					<span v-else-if="stateCar.fuel.type === 0">Л</span>
				</div>
				<div class="car-details_balance"
						 v-on:click="sendCommand( 'update_balance' )">
					<div class="car-details_subtitle">
						Баланс
					</div>
					<div class="car-details_icon">
						<img src="../../assets/img/dashboard/sim.svg">
					</div>
					<span class="m-title">{{stateCar.sim_balance}}</span>руб
					<span v-show="updateSim" class="car-details_balance-update"></span>
				</div>
				<div class="car-details_mark">
					<img v-bind:class="{ 'car-details_mark-away' : !stateCar.is_mark_immobilizer || !stateCar.is_mark_near }"
							src="../../assets/img/carmanager/key-label.svg">
					<span v-if="stateCar.is_mark_immobilizer && stateCar.is_mark_near">в машине</span>
					<span v-if="!stateCar.is_mark_immobilizer || !stateCar.is_mark_near">далеко</span>
				</div>
				<div class="car-details_odometer">
					<div class="car-details_subtitle">
						Пробег
					</div>
					<span class="m-title"
								v-if="!odometer.edit"
								v-on:click="odometerEdit()">{{Math.round(stateCar.odometer)}}</span>
					<input class="m-title" type="text" maxlength="7" id="odometerField"
								 v-model="odometer.value"
								 v-if="odometer.edit"
								 v-on:blur="odometer.edit = false"
								 v-on:keyup="odometerKeyUp()"
								 v-on:keyup.enter="odometerSubmit()">
					<div class="car-details_odometer-change">
						<div class="car-details_odometer-button car-details_odometer-up"
								 v-on:click="odometerUp()">
						</div>
						<div class="car-details_odometer-button car-details_odometer-down"
								 v-on:click="odometerDown()">
						</div>
					</div>
					<div class="clearfix">
					</div>
				</div>
				<div class="car-details_balance">
					<div class="car-details_subtitle">
						Автоштрафы
					</div>
					<div class="car-details_icon">
						<img src="../../assets/img/dashboard/ifine.svg">
					</div>
					<span class="m-title">{{stateCar.fines}}</span>руб
				</div>
			</div>
			<!-- Bottom -->
			<div class="car-details_bottom">
				<div class="car-details_temperatures">
					<div class="car-details_temperatures-item" v-if="stateCar.engine">
						<div id="changeItem">
							<span v-if="listCar[currentIndex].device.type === 1">Двигатель</span>
							<span v-else>В салоне</span>
						</div>
						<div class="car-details_icon">
              <img v-if="listCar[currentIndex].device.type === 1" src="../../assets/img/dashboard/eng_temp.svg">
              <img v-else src="../../assets/img/dashboard/car_temp.svg">
						</div>
						<span class="m-title">{{stateCar.engine.temperature}}°c</span>
					</div>
					<div class="car-details_temperatures-item" v-if="listCar[currentIndex].device.type === 1 && stateCar.cabin_temperature">
						<div>
							В салоне
						</div>
						<div class="car-details_icon">
							<img src="../../assets/img/dashboard/car_temp.svg">
						</div>
						<span class="m-title">{{stateCar.cabin_temperature}}°c</span>
					</div>
					<div class="car-details_temperatures-item" v-if="stateCar.coolant_temperature">
						<div>
              <span>Антифриз</span><!-- v-else -->
						</div>
						<div class="car-details_icon">
							<img src="../../assets/img/dashboard/eng_temp.svg">
						</div>
						<span class="m-title">{{stateCar.coolant_temperature}}°c</span>
					</div>
					<div class="car-details_temperatures-item" v-if="weather.temp">
						<div>
							На улице
						</div>
						<div class="car-details_temperatures-item-cnt">
							<div class="car-details_icon">
								<img v-bind:src="require('../../assets/img/weather/'+ weather.icon + '.png' )">
							</div>
							<span class="m-title">{{weather.temp}}°c</span>
						</div>
					</div>
				</div>
				<!-- OBD II -->
				<div v-if="obd">
					<div class="car-details_subtitle car-details_obd-title">
						Ошибки OBD II
						<span class="car-details_obd-showall"
									v-if="obd.length && obd.length > 1"
									:class="{ 'active' : obdShowall }"
									v-on:click="obdShowall = !obdShowall">
						</span>
					</div>
					<div v-if="obdFilter.length"
							 v-for="item in obdFilter"
							 class="car-details_obd">
						<div class="car-details_obd-date">
							{{item.dt | moment("DD.MM.YYYY")}}
						</div>
						<div v-if="item.data.length">
							<span class="car-details_obd-err"
									  v-for="err in item.data">{{err}}</span>
						</div>
						<div v-else>
							<span class="car-details_obd-err">Нет</span>
						</div>
					</div>
					<div v-if="obdFilter.length === 0">
						<span class="car-details_obd-err">Нет</span>
					</div>
				</div>
			</div>

			<!-- Состояние авто -->
			<Car></Car>
    </div>
    <!-- Комманды -->
    <div class="car-details_commands"
         v-if="accessCar.access_command">
      <div class="car-details_commands-btn"
           v-on:click="toggleCommandPanel()">
        <img src="../../assets/img/commands-setting.svg">
      </div>
      <div class="car-details_commands-cnt"
           v-bind:class="{ 'disabledCMD' : cmdDisabled[currentId] }">
        <div class="car-details_commands-item"
             v-for="element in commands[0].list"
             v-on:click="sendCommand(element.name)">
          <div class="car-details_commands-img">
            <img v-bind:src="pathImg( element.icon )">
          </div>
          <div class="commands-item_name">
            <span v-if="element.name === 'engine_start' && autostart">{{element.title2}}</span>
            <span v-else>{{element.title}}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="car-details_is-offline"
         v-if="!stateCar.is_online">
    </div>
  </div>
</template>

<script>
  import { HTTP, GET_COOKIE } from '../../main'
	import Car from './Managment/Car.vue'

  export default {
    data : function () {
      return{
        batteryVoltageType : 1,
        updateSim : 0,
        odometer : {
          value : '',
          edit : false
        },
        cmdDisabled : {},
				obdShowall : false,
        weather : {}
      }
    },
    created(){
      let res;
      let link = 'https://api.openweathermap.org/data/2.5/weather?lat=' + this.stateCar.lat + '&lon=' + this.stateCar.lng + '&units=metric&appid=38acc18ddc84d2940f0d71ef889ee7f6';

      let getWeather = () => {
        this.$http.get(link)
            .then( response => {
              res = {
                icon : response.body.weather[0].icon,
                temp : response.body.main.temp.toFixed(0),
                time : new Date()
              }
              document.cookie =
                  'weather' + this.currentId + '=' + JSON.stringify( res );

              this.$set(this, 'weather', res);
            })
            .catch( error => {
              console.log(error);
            });
      };

      if( GET_COOKIE('weather' + this.currentId ) ){
        res = JSON.parse(GET_COOKIE('weather' + this.currentId ));
        let diffTime = this.$moment.duration(this.$moment(new Date()).diff(this.$moment(res.time))).asHours();

        if( diffTime >= 1 ){
          getWeather()
        }else{
          this.$set(this, 'weather', res);
        }
      }else{
        getWeather()
      }
    },
    computed : {
      currentIndex : function () {
        return this.$store.state.cars.current.index
      },
      currentId : function () {
        return this.$store.state.cars.current.id
      },
      accessCar : function () {
        return this.$store.state.cars.list[this.currentIndex];
      },
      listCar : function () {
        return this.$store.state.cars.list
      },
      stateCar : function(){
        return this.$store.state.cars.state[this.currentId]
      },
      routeCar : function(){
        return this.$store.state.cars.route[this.currentId]
      },
      timeZone : function(){
        return this.$store.state.timezone
      },
      parkingPeriod : function(){
        let milliseconds = this.$moment()._d - this.$moment( this.routeCar.dt_start ).subtract( this.timeZone, 'minutes')._d;
        if( milliseconds < 0 ){ milliseconds = milliseconds*-1 }

        let seconds = milliseconds / 1000,
          minutes = seconds / 60,
          hours = minutes / 60,
          days = hours / 24;

        if( hours > 23.99 ){
          if( days > 365 ){
            return { 'type' : 0, 'val1' : 'Больше года' }
          }else{
            return {
              'type' : 1,
              'val1' : Math.floor(hours / 24), // дн
              'val2' : Math.floor(hours - Math.floor(hours / 24)*24 ) // ч
            }
          }
        }else{
          return {
            'type' : 2,
            'val1' : Math.floor(minutes / 60), // ч
            'val2' : Math.floor(minutes - Math.floor(minutes / 60)*60 ) // мин
          }
        }
      },
      optionPanel : function () {
        return this.$store.state.panels
      },
      cmdSocket : function () {
        return this.$store.state.cars.lastSocket.cmd
      },
      commands : function () {
        if( this.listCar[this.currentIndex].device.type === 1 ){
          return this.$store.state.commandsUni
        }else{
          return this.$store.state.commandsMobicar
        }
      },
      commandsName : function () {
        return this.$store.state.commandsName
      },
      autostart : function () {
        return this.stateCar.engine.state_id === 6 ||
          this.stateCar.engine.state_id === 7 ||
          this.stateCar.engine.state_id === 8 ||
          this.stateCar.engine.state_id === 9;
      },
      obdFilter : function () {
				if( this.obd && this.obd.length ){
				  if( this.obdShowall ){
				    return this.obd;
					}else{
				  	return this.obd.slice(0, 1)
					}
				}else{
				  return []
				}
      }
    },
    methods : {
      toggleCommandPanel : function () {
        if( this.optionPanel.option.status === 0 ){
          this.$store.dispatch('optionPanel', 1);
          this.$store.dispatch('optionPanelType', 4);
        }else{
          this.$store.dispatch('optionPanel', 0);
          this.$store.dispatch('optionPanelType', 0);
        }
      },
      sendCommand : function ( name ) {
        if( !Object.keys(this.cmdDisabled).length ){
          for( let i = 0; i < this.listCar.length; i++ ){
            this.$set( this.cmdDisabled, this.listCar[i].id, false );
          }
        }
        HTTP.post('cars/' + this.currentId + '/command/', {
          car_id : this.currentId,
          cmd: name
        }).then( () => {
        }).catch( ( error ) => {
          this.$store.dispatch('errorResponse', error );
        });
      },
      changeBatteryVoltageType : function () {
        if( this.batteryVoltageType === 0 ){
          this.batteryVoltageType = 1
        }else{
          this.batteryVoltageType = 0
        }
      },
      odometerEdit(){
        this.odometer.edit = true;

        this.odometer.value = this.stateCar.odometer.toFixed(0);

        setTimeout(function () {
          document.getElementById('odometerField').focus()
        }, 300);
      },
      odometerKeyUp(){
        this.odometer.value = this.odometer.value.replace(/\D/g, '')
      },
      odometerSubmit(){
        let _this = this;

        HTTP.patch('cars/' + this.currentId + '/odometer/', { 'odometer' : parseInt(this.odometer.value) } ).then(function () {
          _this.$store.dispatch( 'addAlert', { text : 'Одометр изменен', type : 'success' });
          _this.stateCar.odometer = parseInt(_this.odometer.value);
          _this.odometer.edit = false;
        }).catch(function (error) {
          _this.$store.dispatch('errorResponse', error );
        });
      },
      odometerUp(){
        let _this = this;

        HTTP.patch('cars/' + this.currentId + '/odometer/', { 'odometer' : _this.stateCar.odometer+1 } ).then(function () {
          _this.$store.dispatch( 'addAlert', { text : 'Одометр изменен', type : 'success' });
          this.stateCar.odometer++;
        }).catch(function (error) {
          _this.$store.dispatch('errorResponse', error );
        });
      },
      odometerDown(){
        let _this = this;

        HTTP.patch('cars/' + this.currentId + '/odometer/', { 'odometer' : _this.stateCar.odometer-1 } ).then(function () {
          _this.$store.dispatch( 'addAlert', { text : 'Одометр изменен', type : 'success' });
          this.stateCar.odometer--;
        }).catch(function (error) {
          _this.$store.dispatch('errorResponse', error );
        });
      },
      pathImg : function ( icon ) {
        if( this.listCar[this.currentIndex].device.type === 1 ){
          return require('@/assets/img/car_button/' + icon + '.svg') ;
        }else{
          return require('@/assets/img/mobicar/commands/' + icon + '.svg');
        }
      },
    },
    watch : {
      'cmdSocket' : function (data) {
        if( data.data.state === 'START' ){
          this.cmdDisabled[this.currentId] = true;
          this.$store.dispatch( 'addAlert', { text : 'Отправлена команда: ' + this.commandsName[data.data.cmd], type : 'success' });
        }else if( data.data.state === 'SUCCESS' ){
          this.cmdDisabled[this.currentId] = false;
          this.$store.dispatch( 'addAlert', { text : 'Выполнена команда: ' + this.commandsName[data.data.cmd], type : 'success' });
        }else if( data.data.state === "TIMEOUT" ){
          this.cmdDisabled[this.currentId] = false;
          this.$store.dispatch( 'addAlert', { text : 'В процессе выполнения команды произошла ошибка', type : 'error' });
        }else if( data.data.state === "FAIL" ){
          this.cmdDisabled[this.currentId] = false;

          this.$store.dispatch( 'addAlert', { text : 'В процессе выполнения команды произошла ошибка', type : 'error' });
        }else if( data.data.state === "INPROCESS" ){
          console.log( data.data );
        }

        // Updata Balance
        if( data.data.cmd === "update_balance" && data.car_id === this.currentId ){
          if( data.data.state === 'START' ){
            this.updateSim = 1;
          }else if( data.data.state === 'SUCCESS' ){
            this.updateSim = 0;
          }
        }
      }
    },
    asyncComputed : {
      parkingAddress : function(){
        return HTTP.get("/cars/" + this.currentId + /address/)
          .then(response => response.data.address );
      },
      obd : function(){
        return HTTP.get( '/cars/' + this.currentId + '/obd-errors/' )
          .then( response => response.data );
      }
    },
		components : {
      Car
		}
  }
</script>